import React from "react";
import lang from "translations";
import styles from "./booking-summary.module.scss";

const BookingSummary = ({ totalBookings, toBeCheckedInCount, toBeCheckedOutCount }) => {
  return (
    <div className={styles.kpis}>
      <div className={`${styles.kpi} ${styles.hero}`}>
        <div className={styles.label}>{lang.totalBookings}</div>
        <div className={styles.value}>{totalBookings || 0}</div>
      </div>
      <div className={styles.kpi}>
        <div className={styles.label}>{lang.toBeCheckedIn}</div>
        <div className={styles.value}>{toBeCheckedInCount || 0}</div>
      </div>
      <div className={styles.kpi}>
        <div className={styles.label}>{lang.toBeCheckedOut}</div>
        <div className={styles.value}>{toBeCheckedOutCount || 0}</div>
      </div>
    </div>
  );
};

export default BookingSummary;
